<div class="select-container">
    <div class="select">
        <select class="select-component" [(ngModel)]="model" (ngModelChange)="onChange($event)" 
                [required]="required" [ngClass]="{'input__invalid': !validate()}" >
            <option value="" disabled selected >{{placeholder}}</option>
            <option *ngFor="let option of options" [value]="option">
                {{option}}
            </option>
        </select>
        <mat-icon>expand_more</mat-icon>
    </div>
</div>
